module.exports = __webpack_public_path__ + "static/img/role.74a59a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/media5/role.png
// module id = W+N/
// module chunks = 7